import * as L from 'leaflet';
import * as Tangram from 'tangram';
const _ = require('lodash')

export default {
  init() {
    this.drawPartnerMap();
  },
  drawPartnerMap() {
    const mapContainer = $('#map')[0];
    
    if (!mapContainer) {
      return;
    }

    const json = $(mapContainer).attr('data-locations');
    const locations = JSON.parse(json);

    const mapOptions = {
      zoomControl: false,
      scrollWheelZoom: false,
      touchZoom: false,
      doubleClickZoom: false,
      attributionControl: false,
      trackResize: false,
      dragging: false,
    };

    const map = L.map(mapContainer, mapOptions);
    const bounds = L.latLngBounds();
    const tileLayer = Tangram.leafletLayer({scene: '../../../../../../../../iron-partner.yaml', attribution: '<a target="_blank" href="http://www.openstreetmap.org/copyright">&copy; OpenStreetMap contributors</a>'});
    const LeafIcon = L.Icon.extend({
      options: {
         iconSize: [30, 55],
         iconAnchor: [20, 50],
      },
    });

    const mapIcon = new LeafIcon({
      iconUrl: 'https://developer.precisely.com/assets/images/defaultmarker.svg',
    });
    
    map.setMaxZoom(4);
    map.addLayer(tileLayer);

    if (locations.length > 1) {
      locations.forEach((location) => {
        L.marker([parseFloat(location.lat), parseFloat(location.lng)], { icon: mapIcon }).addTo(map);
        bounds.extend(L.latLng(parseFloat(location.lat), parseFloat(location.lng)));
      });
      const zoom = Math.round(map.getBoundsZoom(bounds)) - 1;
      map.fitBounds(bounds, {
        maxZoom: 4,
        padding: [50, 50],
      });
      map.setZoom(zoom);
    }

    if (locations.length === 1) {
      const coords = [parseFloat(locations[0].lat), parseFloat(locations[0].lng)];
      L.marker(coords, { icon: mapIcon }).addTo(map);
      map.setView(coords, 4);
    }

    // Refresh map state on window resize
    $(window).on('resize', _.debounce(function () {
      map.invalidateSize();

      if (locations.length > 1) {
        const zoom = Math.round(map.getBoundsZoom(bounds)) - 1;
        map.fitBounds(bounds, {
          maxZoom: 4,
          padding: [50, 50],
        });
        map.setZoom(zoom);
      }
    }, 400));
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singlePartner.js